
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wall-of-love/[publicId]",
      function () {
        return require("private-next-pages/wall-of-love/[publicId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wall-of-love/[publicId]"])
      });
    }
  